import PropertyDetailChipList from './PropertyDetailChipList';

export default PropertyDetailChipList;
